<div class="page-intro py-3">
	<div class="container"><p class="text-center uc mb-0">Une erreur est survenue</p></div>
</div>
<div class="container py-3 page-content">
	<p class="text-center mt-4"><i class="fa fa-8x fa-warning color-red"></i></p>
</div>
<hr class="mt-0"/>
<div class="container py-3 page-content">
	<p class="text-center mt-2"><a href="#default/index" class="btn btn-red"><i class="fa fa-fw fa-chevron-left"></i> Retour</a></p>
</div>
